// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import BulkActionsController from "./bulk_actions_controller"
application.register("bulk-actions", BulkActionsController)

import CaptureTriageController from "./capture_triage_controller"
application.register("capture-triage", CaptureTriageController)

import ChatController from "./chat_controller"
application.register("chat", ChatController)

import ClassificationController from "./classification_controller"
application.register("classification", ClassificationController)

import DispositionController from "./disposition_controller"
application.register("disposition", DispositionController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import KeyboardShortcutsController from "./keyboard_shortcuts_controller"
application.register("keyboard-shortcuts", KeyboardShortcutsController)

import LottieController from "./lottie_controller"
application.register("lottie", LottieController)

import MarkdownController from "./markdown_controller"
application.register("markdown", MarkdownController)

import NavController from "./nav_controller"
application.register("nav", NavController)

import PresetToggleController from "./preset_toggle_controller"
application.register("preset-toggle", PresetToggleController)

import RevealController from "./reveal_controller"
application.register("reveal", RevealController)

import RitualQuestionsController from "./ritual_questions_controller"
application.register("ritual-questions", RitualQuestionsController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)

import UsageBarController from "./usage_bar_controller"
application.register("usage-bar", UsageBarController)
